import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { business } from '../../data/site';
import { whatsappLink } from '../../utils/whatsapp';
type CtaBandProps = {
  title?: string;
  text?: string;
  message?: string;
};
export function CtaBand({
  title,
  text,
  message
}: CtaBandProps) {
  const {
    t
  } = useLanguage();
  return <section className="bg-white px-5 py-16 sm:px-8 sm:py-20" data-id="element-295" data-mp="28sfztd3901dp">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 rounded-3xl bg-mauve-deep px-8 py-12 text-white sm:px-12 lg:flex-row lg:items-center lg:py-14" data-id="element-296" data-mp="28qwidj5uvkac">
        <div className="max-w-xl" data-id="element-297" data-mp="1zt2n8bjtuwor">
          <h2 className="font-display text-3xl font-semibold leading-tight sm:text-4xl" data-id="element-298" data-mp="24qm0p98pb5fn">
            {title ?? t.common.cta.title}
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-white/80" data-id="element-299" data-mp="1pud4yho0ra7z">{text ?? t.common.cta.text}</p>
        </div>
        <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row" data-id="element-300" data-mp="1urwuweu2xbfr">
          <a href={whatsappLink(message)} target="_blank" rel="noreferrer" className="flex h-12 items-center justify-center whitespace-nowrap rounded-full bg-white px-7 text-sm font-medium text-mauve-deep transition-colors duration-150 ease-smooth hover:bg-petal" data-id="element-301" data-mp="qppcf7qowhzs">
            {t.common.cta.primary}
          </a>
          <a href={business.phoneHref} className="flex h-12 items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 px-7 text-sm font-medium text-white transition-colors duration-150 ease-smooth hover:bg-white/10" data-id="element-302" data-mp="800wakrhz64h">
            <PhoneIcon className="h-4 w-4 text-champagne" aria-hidden="true" data-id="element-303" data-mp="guf7oc8wpwib" />
            {t.common.cta.call}
          </a>
        </div>
      </div>
    </section>;
}